<div
  class="imaging-request-tile clickable {{ tileColor }}"
  (click)="openDetails()"
>
  <div class="header-badges">
    @for(headerBadge of headerBadges; track headerBadge) {
    <p class="badge {{ headerBadge?.class }}">
      {{ headerBadge?.display?.toUpperCase() }}
    </p>
    }
  </div>
  <div class="tile-block">
    <p class="patient-name">
      {{ data.patientFirstName }} {{ data.patientLastName }}
    </p>
    {{ data.patientMrn }}
  </div>
  <hr />
  <div class="scan-regions" *ngFor="let scanRegion of scanRegions">
    <mat-icon
      *ngIf="scanRegion.badge"
      class="icon"
      svgIcon="{{ scanRegion.badge }}"
    ></mat-icon>
    <p>{{ scanRegion.modality }} | {{ scanRegion.bodyPart }}</p>
  </div>
  <hr />
  <div>
    <p class="referring-doctor">{{ data.referringDoctor }}</p>
  </div>
</div>
